import { createContext, useContext, useEffect, useState } from "react"
import { apiJSONURL } from "../../App"

const ScheduleContext = createContext({
  isVisible: false,
  serverNow: null,
})

const FORCE_SHOW = false

const SCHEDULED_DATES = new Set([
  "2026-08-10",
  "2026-08-17",
  "2026-08-24",
  "2026-08-31",
])

function shouldShow(serverNow) {
  if (!serverNow) return false

  const [date, time] = serverNow.split(" ")
  const [hour, minute] = time.split(":").map(Number)

  const totalMinutes = hour * 60 + minute

  return (
    SCHEDULED_DATES.has(date) &&
    totalMinutes >= 12 * 60 &&
    totalMinutes < 15 * 60
  )
}

export function ScheduleProvider({ children }) {
  const [serverNow, setServerNow] = useState(null)
  const [isVisible, setIsVisible] = useState(FORCE_SHOW)
  const [date, time] = serverNow ? serverNow.split(" ") : ["", ""]

  useEffect(() => {
    const checkDate = async () => {
      if (FORCE_SHOW) {
        setIsVisible(true)
        return
      }

      try {
        const response = await fetch(`${apiJSONURL}?cmd=now`)
        const data = await response.json()

        setServerNow(data.now) // <-- globally available
        setIsVisible(shouldShow(data.now))
      } catch (err) {
        console.error(err)
      }
    }

    checkDate()

    const interval = setInterval(checkDate, 30_000)

    return () => clearInterval(interval)
  }, [])

  return (
    <ScheduleContext.Provider
      value={{
        isVisible,
        serverNow,
        serverDate: date, //if you want to use date
        serverTime: time, //if you want to use time
      }}
    >
      {children}
    </ScheduleContext.Provider>
  )
}

export function useSchedule() {
  return useContext(ScheduleContext)
}
